<template>
  <div class="page-donations">
    <PostDataWrapper postType="page" slug="donations">
      <template v-slot="slotProps">
        <Page :page="slotProps.post">
          <template v-slot="pageProps">
            <Banner :image-versions="pageProps.featuredImageVersions">
              <h1>{{ pageProps.title }}</h1>
              <p>{{ pageProps.subHeading }}</p>
            </Banner>
          </template>
        </Page>
      </template>
    </PostDataWrapper>

    <PageContainer>
      <ClientOnly>
        <DonationList />
      </ClientOnly>
    </PageContainer>
  </div>
</template>

<script>
import page from '@/mixins/page'

import Banner from '@/components/Banner'
import PageContainer from '@/components/PageContainer'
import DonationList from '@/components/donations/DonationList'
import ClientOnly from '@/components/ClientOnly'

export default {
  name: 'Donations',

  mixins: [page],

  components: {
    Banner,
    DonationList,
    PageContainer,
    ClientOnly
  }
}
</script>

<style lang="sass" scoped>
.page-donations
</style>
